import React from 'react';
import axios from 'axios';
import { toaster } from '../../ui/component/toaster/toaster.tsx';
import { ServerError } from './model/server-error.ts';
import { ExceptionType } from './valueobject/exception-type.ts';
import { PaymentFailureType } from './valueobject/payment-failure-type.ts';

export interface AxiosClientProviderProps {
  children?: React.ReactNode;
}

// eslint-disable-next-line react-refresh/only-export-components
export const apiClient = axios.create();

/**
 * Erstellt einen Axios Provider mit Fehler-Anzeige
 */
export default function AxiosClientProvider({ children }: AxiosClientProviderProps) {
  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      // 503-Fehler: Leite zur Startseite weiter
      if (error.response?.status === 503) {
        window.location.href = '/';
        return Promise.reject(error);
      }

      const serverError = ServerError.validateSingle(error.response.data);

      if (serverError.type === ExceptionType.TECHNICAL_ERROR) {
        // Wir müssen warten, bis der ChakraUi Kontext da ist, das passiert z. B. wenn im loader ein
        // Fehler auftritt, sonst wird kein Toast angezeigt!
        setTimeout(() => {
          toaster.create({
            type: 'error',
            title: 'Fehler',
            description: error.message,
            closable: true,
            duration: 5_000,
          });
        }, 750);
      }

      if (serverError.type === ExceptionType.PAYMENT_ERROR) {
        const paymentFailureType = serverError.exceptionArguments[1];

        if (paymentFailureType === PaymentFailureType.TICKETDETAILS_NICHT_LADBAR_NACH_ERFOLGREICHER_ZAHLUNG) {
          // Die Zahlung war erfolgreich, nur die Anzeige der Ticketdetails ist fehlgeschlagen - wir leiten
          // direkt auf die Ticket-Detailseite um, statt eine (hier irreführende) Fehlerseite zu zeigen.
          const ticketnummerOderKennzeichen = serverError.exceptionArguments[2];
          window.location.href = `/ticket/ansicht/${ticketnummerOderKennzeichen}`;
        } else {
          const params = new URLSearchParams();
          params.append('transaktionsId', serverError.exceptionArguments[0]);
          params.append('paymentFailureType', paymentFailureType);

          window.location.href = `/paymentError?${params.toString()}`;
        }
      }

      return Promise.reject(error);
    },
  );
  return children;
}
